module.exports = __webpack_public_path__ + "img/lock.2980b3f2.png";